(function () {

  'use strict';

  function pxScimDisableForm(IdpProviderService) {
    return {
      restrict: 'E',
      scope: {
        context: '=context',
        callback: '&callback'
      },
      templateUrl: 'app/components/authenticationSettings/_scimDisableForm/scimDisableForm.template.html',
      link: function (scope) {

        scope.scimDisable = {
          confirm: false,
          submitting: false
        };

        scope.idp = scope.context.idp.info ? scope.context.idp.info : scope.context.idp;

        scope.cancel = function () {
          scope.callback();
        };

        scope.disable = function () {
          if (scope.scimDisable.submitting) {
            return;
          }
          scope.scimDisable.submitting = true;
          IdpProviderService.disableScim(scope.context.scimUrl)
            .then(function () {
              scope.callback();
            })
            .catch(function (error) {
              scope.callback();
              IdpProviderService.handleScimError(error);
            })
            .finally(function () {
              scope.scimDisable.submitting = false;
            });
        };
      }
    };
  }

  pxScimDisableForm.$inject = ['IdpProviderService'];

  angular
    .module('printix-admin')
    .directive('pxScimDisableForm', pxScimDisableForm);

})();
